
export default [
  {
    "ref": "conor",
    "name": "Conor Vanek",
    "avatar": "https://gravatar.com/avatar/51990641c18fec7cf059952788b92ea32d5f2d486f144480ed3319933df4dabb",
    "content": "",
    "_meta": {
      "filePath": "authors/conor.mdx",
      "fileName": "conor.mdx",
      "directory": "authors",
      "extension": "mdx",
      "path": "authors/conor"
    }
  },
  {
    "ref": "trevor",
    "name": "Trevor Wieland",
    "avatar": "https://1.gravatar.com/avatar/6e194d88ddb5b381a56372aef11e6f95c8683d1b9a8e622ceffbf6b935634e8a",
    "content": "",
    "_meta": {
      "filePath": "authors/trevor.mdx",
      "fileName": "trevor.mdx",
      "directory": "authors",
      "extension": "mdx",
      "path": "authors/trevor"
    }
  }
]